import { makeStyles } from '@material-ui/core/styles';

import type { Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.primary,
    boxShadow: '0px 1px 0.5px rgba(0,0,0,0.05), 0px 0px 4px rgba(0,0,0,0.15)',
    borderRadius: 8,
    padding: theme.spacing(2),
    maxWidth: 400,
  },
  arrow: {
    color: theme.palette.common.white,
  },
  trigger: {
    display: 'inline-block',
    maxWidth: '100%',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  appIcon: {
    width: 32,
    height: 32,
    flexShrink: 0,
  },
  headerText: {
    fontSize: 10,
    fontWeight: 700,
    letterSpacing: '0.8px',
    textTransform: 'uppercase',
    color: theme.palette.text.primary,
  },
  card: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 8,
    padding: theme.spacing(2),
    minWidth: 280,
  },
  cardTitle: {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '20px',
    marginBottom: theme.spacing(1),
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    minHeight: 20,
    '& + &': {
      marginTop: theme.spacing(1),
    },
  },
  dot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    flexShrink: 0,
    margin: 4,
  },
  dotCompliant: {
    backgroundColor: theme.palette.success.main,
  },
  dotPendingReview: {
    backgroundColor: theme.palette.warning.main,
  },
  dotNotCompliant: {
    backgroundColor: theme.palette.error.main,
  },
  name: {
    fontSize: 14,
    lineHeight: '20px',
    flexGrow: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  status: {
    fontSize: 14,
    lineHeight: '20px',
    color: theme.palette.text.secondary,
    flexShrink: 0,
  },
}));

export default useStyles;
